require('./hireNewCardSidebar.scss');

import React from 'react';

import { i18n } from 'core/i18n';
import PersonalDataHelper from 'utilities/personalDataHelper';
import { formatAmountObject } from 'utilities/currencyHelper';
import { getLastNChars } from 'utilities/stringHelper';
import { OKSectionBox } from 'commonsComponents/OKSectionBox';
import { LoadingSection } from 'commonsComponents/loadingSection';
import { OneLineSymbolAmount } from 'commonsComponents/oneLineSymbolAmount';
import {
    CARD_PAYMENT_METHOD_FIXED,
    CARD_PAYMENT_METHOD_UNIQUE,
    CARD_PAYMENT_METHOD_VARIABLE,
    EURO_TEXT,
    HYPHEN, 
    VIA_T
} from 'constants/index';

export const HireNewCardSidebar = ({
    immHireCardImageSelector,
    immHireCreditLimit,
    immHirePaymentMethod,
    immOpenYoungInterveners,
    immAccounts,
    immHireCardNameSelector,
    selectedAccount,
    hasShippingAddress,
    immAddress,
    immProfile,
    isViaT,
    immShippingAddressList,
    immPdfRevolvingPersistent,
    cardType
}) => {
    const { FormattedText, formatText, getLanguage } = i18n;
    const CREDIT_LABELS = [
        'selectedLimit',
        'paymentMethod',
        'paymentMethodAmount',
        'tin',
        'tae',
        'separator',
        'selectedAccount',
        'selectedNameForCard'
    ];


    const buildImageContent = () => {

        const selectedImageId = immHireCardImageSelector.get('selectedImageId');
        const fetchSuccess = immHireCardImageSelector.get('fetchSuccess');

        let content;
        if (fetchSuccess && !!selectedImageId) {
            const imgSrc = immHireCardImageSelector.getIn(['imagesById', selectedImageId, 'url']);

            content = (
                <div className="hire-card-sidebar__image-container">
                    <img className="hire-card-sidebar__image" src={imgSrc} />
                </div>
            );
        }

        return content;
    }
    const buildField = (label, index) => {
        if (label === 'separator') {
            return <div key={index} className="hire-card-sidebar__separator" />;
        } else {
            const value = getFieldValue(label);

            let valueContent;
            if (!!value) {
                valueContent = (
                    <div className="hire-card-sidebar__value">
                        {value}
                    </div>
                );
            } else {
                valueContent = (
                    <div className="hire-card-sidebar__pending-value">
                        <FormattedText value="hireCardSidebar-pendingValue" />
                    </div>
                );
            }
            return (
                cardType === VIA_T && label === 'selectedNameForCard' ? null : (
                    <section key={index} className="hire-card-sidebar__field">
                        <FormattedText
                            value={`hireCardSidebar-${label}`}
                            className="hire-card-sidebar__label"
                        />
                        {valueContent}
                    </section>
                )
            );
        }
    }
    const buildFieldsContent = () => {
        return CREDIT_LABELS.map((label, index) => {
            const CREDIT_LABELS_OPTIONAL = ['paymentMethodAmount', 'tin', 'tae'];
            const paymentMethodType = immHirePaymentMethod.get('type');

            if ((!paymentMethodType || paymentMethodType === CARD_PAYMENT_METHOD_UNIQUE)
                && CREDIT_LABELS_OPTIONAL.includes(label)) {
                return;
            }

            return buildField(label, index);
        })
    }
    const buildOpenYoungInterveners = () => {
        const interveners = immOpenYoungInterveners.map((immIntervener, index) => (
            <li
                className="hire-card-sidebar__value hire-card-sidebar__value--list-item"
                key={index}
            >
                {immIntervener.get('name')}
            </li>
        ));

        return (
            <div className="hire-card-sidebar__field">
                <FormattedText
                    className="hire-card-sidebar__label hire-card-sidebar__label--margin-top"
                    value="hireCardSidebar-hireCardSidebar_intervenerLegalRepresentative"
                />
                <ul className="hire-card-sidebar__list-container">
                    {interveners}
                </ul>
            </div>
        );
    }
    const getFieldValue = (label) => {
        let paymentMethodType = immHirePaymentMethod.get('type');
        switch (label) {
            case 'selectedLimit':
                if (immHireCreditLimit.get('fetchSuccess')) {

                    const amountObj = {
                        amount: immHireCreditLimit.get('creditLimit'),
                        currency: EURO_TEXT
                    };
                    return (
                        <div className="hire-card-sidebar__value--important">
                            <OneLineSymbolAmount
                                amountObject={amountObj}
                                language={getLanguage()}
                                amountObjectFormatted={formatAmountObject(amountObj, true)}
                                trimDecimals={true}
                            />
                        </div>
                    );
                } else {
                    return '';
                }
            case 'selectedNameForCard':
                if (!!immHireCardNameSelector) {
                    return immHireCardNameSelector.getIn(['names', immHireCardNameSelector.get('selectedIndex')]);
                } else {
                    return '';
                }
            case 'paymentMethod':
                if (!!paymentMethodType) {
                    const paymentMethod = {
                        [CARD_PAYMENT_METHOD_UNIQUE]: `${formatText('hireCardSidebar-methodOfPaymentFullPay')}`,
                        [CARD_PAYMENT_METHOD_FIXED]: `${formatText('hireCardSidebar-methodOfPaymentDeferredFixedFee')}`,
                        [CARD_PAYMENT_METHOD_VARIABLE]: `${formatText('hireCardSidebar-methodOfPaymentDeferredVariableFee')}`
                    };
                    return paymentMethod[paymentMethodType];

                } else {
                    return '';
                }
            case 'paymentMethodAmount':
                if (paymentMethodType === CARD_PAYMENT_METHOD_FIXED) {
                    const amountObj = {
                        amount: immHirePaymentMethod.get('value'),
                        currency: EURO_TEXT
                    };

                    return (
                        <OneLineSymbolAmount
                            amountObject={amountObj}
                            language={getLanguage()}
                            amountObjectFormatted={formatAmountObject(amountObj, true)}
                        />
                    );
                } else if (paymentMethodType === CARD_PAYMENT_METHOD_VARIABLE) {
                    return `${immHirePaymentMethod.get('value')} %`;
                } else {
                    return '';
                }
            case 'selectedAccount':

                if (!!selectedAccount) {
                    const immAccount = immAccounts.getIn(['byId', selectedAccount]);
                    const accountIban = getLastNChars(immAccount.get('iban'));

                    return (
                        <div>
                            <span>{immAccount.get('alias')}</span>
                            &nbsp;
                            <span>{accountIban}</span>
                        </div>
                    );
                } else {
                    return '';
                }

            case 'tae':
                return immPdfRevolvingPersistent.getIn(['paramsInne', 'tae']);
            case 'tin':
                return immPdfRevolvingPersistent.getIn(['paramsInne', 'tin']);
            default:
                return '';
        }
    }
    const buildAddressContent = () => {


        let content;
        const addressKey = isViaT ? 'shippingAddressViaT' : 'shippingAddress';

        if (hasShippingAddress && immAddress) {
            if (!immAddress.getIn(['country', 'value'])) {
                const shippingAddress = (immAddress.isEmpty()) ? HYPHEN : PersonalDataHelper.getHireFormattedShippingAddress(immShippingAddressList, immAddress.getIn(['country', 'value']));
                content = <p>{shippingAddress}</p>;
            } else {
                const shippingAddress = (immAddress.isEmpty()) ? HYPHEN : PersonalDataHelper.getHireFormattedAddress(immAddress);
                content = (
                    <p>{shippingAddress}</p>
                );
            }
        } else {
            if (immProfile.get('isFetching')) {
                content = <LoadingSection />;
            } else {
                const address = PersonalDataHelper.getFormattedAddress(immProfile);
                content = <p>{address}</p>;
            }
        }

        return (
            <section className="hire-card-sidebar__field">
                <FormattedText
                    value={`hireCardSidebar-${addressKey}`}
                    className="hire-card-sidebar__label"
                />
                <div className="hire-card-sidebar__value">
                    {content}
                </div>
            </section>
        );
    }

    const fieldsContent = buildFieldsContent();

    return (
        <OKSectionBox className="hire-card-sidebar">
            <section>
                {buildImageContent()}
                <h3 className="hire-card-sidebar__title">
                    <FormattedText value="hireCardSidebar-title" />
                </h3>
                {fieldsContent}
                {cardType !== 'virtual' && (
                    <>
                        <div className="hire-card-sidebar__separator" />
                        {buildAddressContent()}
                    </>
                )}
            </section>
        </OKSectionBox>
    );
};
